import React, { memo, useCallback, useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { Layout, SelectableCard } from "../../../components";
import { tooltips } from "../constants/tooltips";
import { formControls } from "../constants/forms";
import FieldTooltip from "./FieldTooltip";
import {
    WHICHENSURE_TYPES,
    WHICHENSURE_TYPE_VALUES,
} from "../../../constants/personaldata";

const FieldWhichEnsure = () => {
    const { setValue } = useFormContext();
    const items = useMemo(() => WHICHENSURE_TYPE_VALUES, []);
    const handleOnSelect = useCallback(
        value => {
            setValue(formControls.whichEnsure.key, value, true);
        },
        [setValue]
    );

    return (
        <div>
            <label
                id="whichEnsure"
                htmlFor={formControls.whichEnsure.key}
                className="form-control__label"
            >
                <Layout align="center">
                    {formControls.whichEnsure.label}
                    <FieldTooltip content={tooltips.whichEnsure} />
                </Layout>
            </label>
            <SelectableCard
                aria-labelledby="whichEnsure"
                items={items}
                defaultValue={WHICHENSURE_TYPES.HOUSING_ASSETS}
                handleOnSelect={handleOnSelect}
            />
        </div>
    );
};

export default memo(FieldWhichEnsure);
